import React, { FC, ReactNode } from 'react';

import CatalogueNavigation from '../../shop/catalogue/CatalogueNavigation';
import SelectionListNavigation from '../navigation/SelectionListNavigation';
import ReserveDetailNavigation from '../navigation/ReserveDetailNavigation';
import CartNavigation from '../navigation/CartNavigation';
import { ShopProductDetailNavigation } from '../navigation/ProductDetailNavigation';
import { BundleDetailNavigation } from '../navigation/BundleDetailNavigation';
import OrdersNavigation from '../../shop/orders/OrdersNavigation';
import UnlimitedNavigation from '../navigation/UnlimitedNavigation';
import SearchNavigation from '../search/SearchNavigation';
import { CartPreview } from '../../shop/cart/CartPreview';
import LocalContentNavigation from '../../yourborrowbox/navigation/LocalContentNavigation';
import CollectionNavigation from '../../yourborrowbox/navigation/CollectionNavigation';
import LibxNavigation from '../../yourborrowbox/navigation/LibxNavigation';
import ForeignLanguageNavigation from '../navigation/ForeignLanguageNavigation';
import LoteNavigation from '../navigation/LoteNavigation';
import LanguageLearningNavigation from '../navigation/LanguageLearningNavigation';
import MarketingNavigation from '../../yourborrowbox/navigation/MarketingNavigation';
import OrderAssistantNavigation from '../navigation/OrderAssistantNavigation';
import ReserveCheckoutNavigation from '../../shop/reserve/components/ReserveCheckoutNavigation';
import { Route, Switch } from 'react-router';
import { Orderlist } from '../../../models/OrderList';
import { SpocState } from '../../store/authentication/state';
import { OrderListState } from '../../store/orderlist/state';
import { NavigationLink } from '../navigation/NavigationLink';
import { UseCartSummaryQuery } from '../../api/shopping-cart/useCartSummaryQuery';

export type ScrollHeaderProps = {
    readonly show: boolean;
    readonly activeList?: Orderlist;
    readonly orderlist: OrderListState;
    readonly spoc: SpocState;
    readonly productTitle?: string;
    readonly toggleFilterDisplay: () => void;
    readonly onOpenSearchBar: () => void;
    readonly searchbar: ReactNode;
    readonly cartSummaryQuery: UseCartSummaryQuery;
};

export const ScrollHeader: FC<ScrollHeaderProps> = ({
    show,
    orderlist,
    spoc,
    searchbar,
    onOpenSearchBar,
    toggleFilterDisplay,
    productTitle,
    activeList,
    cartSummaryQuery
}) => {
    return (
        <div
            className="header-sticky header-container"
            data-displayname="ScrollHeader"
            style={{ display: !show ? 'none' : undefined }}
        >
            <Switch>
                <Route path="/catalogue/:loanFormat/products">
                    <ul className="main-nav main-nav--sticky">
                        <li>
                            <a onClick={toggleFilterDisplay} role="button" className="filter-toggle">
                                <i className="material-icons bigger">list</i>
                            </a>
                        </li>
                    </ul>
                </Route>
                <Route path="/catalogue">
                    <ul className="main-nav main-nav--sticky">
                        <li>
                            <NavigationLink to="/catalogue" activeClassName={undefined}>
                                Shop
                            </NavigationLink>
                        </li>
                    </ul>
                </Route>
            </Switch>
            <div className="header-sticky-nav-right fl-right display-flex">
                <div className="search-icon">
                    {searchbar}
                    <i className="material-icons icn-search" onClick={() => onOpenSearchBar()}>
                        search
                    </i>
                </div>
                <CartPreview cartSummaryQuery={cartSummaryQuery} />
            </div>
            <Switch>
                <Route path="/assistant/reserve/:reserveListId" exact={true}>
                    <ReserveDetailNavigation isSticky={true} />
                </Route>
                <Route path="/assistant/reserve/:reserveListId/checkout">
                    <ReserveCheckoutNavigation isSticky={true} />
                </Route>
                <Route path="/assistant/reserves">
                    <OrderAssistantNavigation isSticky={true} />
                </Route>
                <Route path="/bundles/:bundleId">
                    <BundleDetailNavigation isSticky={true} />
                </Route>
                <Route path="/cart">
                    <CartNavigation isSticky={true} isCheckout={false} />
                </Route>
                <Route path="/catalogue">
                    <CatalogueNavigation showAgeSelector={false} isSticky={true} />
                </Route>
                <Route path="/checkout">
                    <CartNavigation isSticky={true} isCheckout={true} />
                </Route>
                <Route path="/collection">
                    <CollectionNavigation isSticky={true} showAgeSelector={false} />
                </Route>
                <Route path="/language/lote/:languageId/featured">
                    <LoteNavigation isSticky={true} />
                </Route>
                <Route path="/language/lote/:languageId/newlyadded">
                    <LoteNavigation isSticky={true} />
                </Route>
                <Route path="/language/lote/:languageId/genres">
                    <LoteNavigation isSticky={true} />
                </Route>
                <Route path="/language/lote/:languageId/products">
                    <LoteNavigation isSticky={true} />
                </Route>
                <Route path="/language/languagelearning/:languageId/featured">
                    <LanguageLearningNavigation isSticky={true} />
                </Route>
                <Route path="/language/languagelearning/:languageId/newlyadded">
                    <LanguageLearningNavigation isSticky={true} />
                </Route>
                <Route path="/language/languagelearning/:languageId/products">
                    <LanguageLearningNavigation isSticky={true} />
                </Route>
                <Route path="/language">
                    <ForeignLanguageNavigation isSticky={true} />
                </Route>
                <Route path="/libxchange">
                    <LibxNavigation isSticky={true} showAgeSelector={false} />
                </Route>
                <Route path="/localcontent">
                    <LocalContentNavigation isSticky={true} productTitle={productTitle} />
                </Route>
                <Route path="/orderlists">
                    <SelectionListNavigation isSticky={true} activeList={activeList} spoc={spoc} {...orderlist} />
                </Route>
                <Route path="/orders">
                    <OrdersNavigation isSticky={true} />
                </Route>
                <Route path="/products/:productId">
                    <ShopProductDetailNavigation isSticky={true} />
                </Route>
                <Route path="/search">
                    <SearchNavigation isSticky={true} />
                </Route>
                <Route path="/unlimited">
                    <UnlimitedNavigation isSticky={true} />
                </Route>
                <Route path="/marketing">
                    <MarketingNavigation isSticky={true} />
                </Route>
            </Switch>
        </div>
    );
};
